export class Colors {
  static readonly ACTIVE_BACKGROUND = 'var(--green-500)'
  static readonly ACTIVE_TEXT = 'var(--black)'
  static readonly INACTIVE_BACKGROUND = 'var(--red-700)'
  static readonly INACTIVE_TEXT = 'var(--white)'
  static readonly PENDING_BACKGROUND = 'var(--blue-700)'
  static readonly PENDING_TEXT = 'var(--white)'
}

export const CARD_COLORS = {
  light: ['var(--light-blue-50)', 'var(--purple-50)', 'var(--green-50)', 'var(--blue-50)', 'var(--yellow-50)'],
  dark: ['var(--light-blue-700)', 'var(--purple-500)', 'var(--green-600)', 'var(--blue-500)', 'var(--yellow-700)']
}

export const ORG_CARD_COLORS = ['var(--red-50)', 'var(--yellow-50)', 'var(--green-50)', 'var(--blue-50)', 'var(--purple-50)']
export const ORG_AVATAR_COLORS = ['var(--red-700)', 'var(--yellow-700)', 'var(--green-600)', 'var(--blue-500)', 'var(--purple-500)']
